var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 120,
    viewBox: "0 -35 183 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 82,
    width: 183,
    height: 38,
    rx: 8,
    fill: "#FFC107",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5 18C88.5 13 94.5 13 97.5 18L145 98C148 103 144.5 110 138.5 110H44.5C38.5 110 35 103 38 98L85.5 18Z",
    fill: "none",
    stroke: "#FFB300",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.25,
    y: 48,
    width: 6.5,
    height: 28,
    rx: 3.25,
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 88,
    r: 5.5,
    fill: "#FFB300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fc20d4cb167e02ccf1c6ffa10b7f09e6.svg";
export { ForwardRef as ReactComponent };